<template>
  <v-container fluid id="welcome" class="section-height pa-0">
    <v-row no-gutters>
      <!--            Большой экран-->
      <v-col cols="6" v-if="$vuetify.breakpoint.mdAndUp">
        <v-img
          src="@/images/main.jpg"
        />
      </v-col>
      <main-info v-if="$vuetify.breakpoint.mdAndUp"/>
      <!--          маленький экран-->
<!--      todo height of image-->
      <v-col cols="12" v-if="!$vuetify.breakpoint.mdAndUp">
        <v-img
          height="100vh"
          src="@/images/main.jpg"
          class="d-flex align-end justify-center"
        >
          <main-info light/>
        </v-img>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import MainInfo from "@/components/MainInfo";

export default {
  name: "MainDisplay"
  ,
  components: {
    MainInfo
  }
}
</script>

<style scoped>

</style>